<template>
	<section
		ref="sectionRef"
		class="brand-philosophy"
		:aria-label="t(`${I18N_NS}.brandPhilosophy.ariaLabel`)"
	>
		<div class="brand-philosophy__inner pc-center-1200">
			<header class="brand-philosophy__header">
				<img
					class="brand-philosophy__decor"
					src="../../images/title-decor-left.png"
					alt=""
					aria-hidden="true"
				/>
				<h2 class="brand-philosophy__title">{{ t(`${I18N_NS}.brandPhilosophy.title`) }}</h2>
				<img
					class="brand-philosophy__decor"
					src="../../images/title-decor-right.png"
					alt=""
					aria-hidden="true"
				/>
			</header>

			<p class="brand-philosophy__subtitle">
				{{ t(`${I18N_NS}.brandPhilosophy.subtitle`) }}
			</p>

			<p class="brand-philosophy__desc">
				{{ t(`${I18N_NS}.brandPhilosophy.desc`) }}
			</p>
		</div>
	</section>
</template>

<script setup>
import { nextTick, onMounted, ref } from "vue";
import { useI18n } from "~/composables/useI18n";
import { ABOUT_SECTION_ID, useAboutUsTracking } from "../../../composables/useAboutUsTracking";

const I18N_NS = "aboutUs";
const { t } = useI18n();
const { track, observeImpression } = useAboutUsTracking("pc");
const sectionRef = ref(null);

onMounted(() => {
	nextTick(() => {
		observeImpression("about_brand_section_view", sectionRef, () => {
			track("about_brand_section_view", {
				section_id: ABOUT_SECTION_ID.BRAND_CONCEPT,
			});
		});
	});
});
</script>

<style lang="scss" scoped>
.brand-philosophy {
	background: #fffdf9;
	padding: 56px 0 59px;

	&__inner {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	&__header {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 16px;
		margin-bottom: 12px;
	}

	&__decor {
		width: 120px;
		height: 16px;
		object-fit: contain;
		flex-shrink: 0;
	}

	&__title {
		margin: 0;
		color: #333333;
		font-size: 42px;
		font-weight: 700;
		line-height: 60px;
		white-space: nowrap;
	}

	&__subtitle {
		margin: 0 0 30px;
		color: #333333;
		font-size: 32px;
		line-height: 46px;
		text-align: center;
	}

	&__desc {
		margin: 0;
		width: 100%;
		max-width: 1300px;
		color: #505050;
		font-size: 22px;
		font-weight: 400;
		line-height: 33px;
		letter-spacing: 2px;
		text-align: justify;
	}
}

@media (max-width: 1024px) {
	.brand-philosophy {
		padding: 48px 0;

		&__title {
			font-size: 36px;
			line-height: 1.4;
		}

		&__subtitle {
			font-size: 26px;
			line-height: 1.4;
		}

		&__desc {
			font-size: 18px;
			line-height: 1.6;
			letter-spacing: 1px;
		}
	}
}

@media (max-width: 768px) {
	.brand-philosophy {
		padding: 40px 0;

		&__decor {
			width: clamp(48px, 16vw, 80px);
			height: 12px;
		}

		&__header {
			gap: 10px;
		}

		&__title {
			white-space: normal;
			font-size: 28px;
		}

		&__subtitle {
			margin-bottom: 20px;
			font-size: 20px;
		}

		&__desc {
			font-size: 16px;
			line-height: 1.7;
			letter-spacing: 0;
			text-align: left;
		}
	}
}
</style>
